require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-микросервисная-архитектура-grpc.json") })
        }
      }, "path---projects-микросервисная-архитектура-grpc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-микросервисная-архитектура-grpc!./.cache/json/projects-микросервисная-архитектура-grpc.json
// module id = 359
// module chunks = 231608221292675